import React, { Component } from 'react';
import { Container, Header, Button, Table, Menu } from 'semantic-ui-react';
import schedule from '../data/schedule';

import '../styles/scheduleSection.scss';

class ScheduleSection extends Component {
    constructor() {
        super();
        this.state = {
            day: schedule['15th'],
            activeDay: '15th'
        }
    }

    setDay(day) {
        this.setState({day: schedule[day]})
    }
    handleItemClick = (e, { name }) => {
        console.log(name);
        const str = name.replace(/\s/g, '').toLowerCase();
        this.setState({ day: schedule[str], activeDay: str })
    }

render() {
    const {day,activeDay} = this.state;
    return <section id="schedule" className="content-deck schedule">
        <h1 className="content-deck__headline">
          Schedule
        </h1>
        <Container className="schedule__container" textAlign="center">
          <Menu className="schedule__menu" inverted pointing secondary >
            <Menu.Item name="15th" active={activeDay === '15th'} onClick={this.handleItemClick} />
            <Menu.Item name="16th" active={activeDay === '16th'} onClick={this.handleItemClick} />
            <Menu.Item name="17th" active={activeDay === '17th'} onClick={this.handleItemClick} />
            <Menu.Item name="18th" active={activeDay === '18th'} onClick={this.handleItemClick} />
          </Menu>

            <Table unstackable compact inverted basic="very">
            <Table.Body>
              {day.map((d, i) => {
                return <Table.Row key={`${d.timeslot}-${i}`}>
                    <Table.Cell singleLine>{d.timeslot}</Table.Cell>
                    <Table.Cell singleLine={false} style={{textAlign: 'left'}}>{d.activity}</Table.Cell>
                    {/* <Table.Cell>{d.location}</Table.Cell> */}
                  </Table.Row>
              })}
            </Table.Body>
          </Table>

          <Button className="download-button" href="/download" inverted size='medium' color="teal"> Download the App</Button> <br/>
          <Button target="_blank" className="download-button" href="https://www.core-apps.com/dl/pmena18" inverted size='medium' color="teal"> Online Program</Button>
          <Button target="_blank" className="download-button" href="https://s3.us-east-2.amazonaws.com/pmena2018/documents/public/PMENA+2018+Conference+Schedule.pdf" inverted size='medium' color="teal"> Print Program</Button>
        </Container>
      </section>
}
}

export default ScheduleSection


// WEBPACK FOOTER //
// ./src/sections/scheduleSection.js